export default __webpack_public_path__ + "static/media/icon_qr.0833fd11.svg";